var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrinkIcon05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 289.9 95",
    style: {
      enableBackground: "new 0 0 289.9 95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A8BE5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glass01"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,71.3c-0.4,0-0.7-0.1-1-0.5l-26.6-30c-0.5-0.5-0.5-1.4,0.1-1.9c0.3-0.2,0.5-0.3,0.9-0.3h53.3 c0.7,0,1.4,0.6,1.4,1.4c0,0.3-0.1,0.7-0.3,0.9l-26.6,30C32.3,71.1,32,71.3,31.5,71.3z M8,41.3l23.6,26.6l23.6-26.6H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 69.9,
    className: "st0",
    width: 2.7,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 90.4,
    className: "st0",
    width: 16.1,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 48.7,
    className: "st0",
    width: 35,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 43.5,
    transform: "matrix(0.2691 -0.9631 0.9631 0.2691 -14.8409 70.181)",
    className: "st0",
    width: 24.9,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,37.1c-0.1,0-0.3,0-0.3-0.1l-23.4-6.5c-0.7-0.2-1.2-1-1-1.7c0.1-0.5,0.5-0.8,1-1l13.8-4 c0.5-0.1,1,0,1.4,0.4l9.6,10.5c0.5,0.5,0.5,1.4-0.1,1.9C54.6,37,54.2,37.1,53.9,37.1z M35.5,29.2l14.2,4l-5.8-6.3L35.5,29.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "glass02"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.3,93.1h-25.7c-5.6,0-10.1-4.6-10.1-10.1V33.5c0-0.7,0.6-1.4,1.4-1.4h43.2c0.7,0,1.4,0.6,1.4,1.4V83 C274.4,88.6,269.9,93.1,264.3,93.1z M231.2,34.8V83c0,4.1,3.3,7.4,7.4,7.4h25.7c4.1,0,7.4-3.3,7.4-7.4V34.8H231.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.1,
    y: 41,
    className: "st0",
    width: 2.7,
    height: 42.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.6,
    y: 41,
    className: "st0",
    width: 2.7,
    height: 42.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.3,
    y: 41,
    className: "st0",
    width: 2.7,
    height: 42.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.5,77.8h-9.8V43.3h9.8c3.5,0,6.4,2.9,6.4,6.4v21.8C287.9,75,285,77.8,281.5,77.8z M274.4,75.1h7.1 c2,0,3.7-1.6,3.7-3.7V49.6c0-2-1.6-3.7-3.7-3.7h-7.1V75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.7,33.3c-3.7-3.1-4.2-8.6-1.1-12.3c2.4-2.9,6.3-3.9,9.7-2.5l0.9,0.3l0.7-0.6c5.7-4.9,14.4-4.2,19.3,1.6 c0.1,0.1,0.1,0.1,0.2,0.3l0.5,0.6l0.8-0.1c0.6-0.1,1.2,0,1.8,0.1c4,0.7,6.6,4.4,5.9,8.4c-0.3,1.6-1.1,3.1-2.3,4.2h4.1 c3-4.9,1.5-11.3-3.4-14.3c-1.6-1-3.5-1.6-5.5-1.6c-5.9-6.5-15.7-7.5-22.8-2.2c-6.3-1.8-12.9,1.7-14.7,8c-1,3.4-0.4,7.1,1.6,10 L232.7,33.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "glass03"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.9,70.9c-6.1,0-11.7-3.6-14.2-9.2c-1.4-3.1-4.5-5-7.8-5c-6.3,0-11.4-5.1-11.4-11.4v-6.2 c0-0.7,0.6-1.4,1.4-1.4h64.3c0.7,0,1.4,0.6,1.4,1.4v6.2c0,6.3-5.1,11.4-11.4,11.4c-3.4,0-6.5,2-7.8,5 C202.6,67.3,197.1,70.9,190.9,70.9z M160.2,40.5v4.8c0,4.8,3.9,8.7,8.7,8.7c4.4,0,8.5,2.6,10.4,6.7c2.9,6.5,10.6,9.4,17,6.5 c2.9-1.3,5.2-3.6,6.5-6.5c1.8-4.1,5.9-6.7,10.4-6.7c4.8,0,8.7-3.9,8.7-8.7v-4.8C221.7,40.5,160.2,40.5,160.2,40.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.3,
    y: 47.1,
    className: "st0",
    width: 63.2,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.6,
    y: 69.6,
    className: "st0",
    width: 2.7,
    height: 22.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.8,
    y: 90.4,
    className: "st0",
    width: 22.2,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,49.1c-5.5-2.2-8.2-8.4-6.1-13.9c2.2-5.5,8.4-8.2,13.9-6.1c2.9,1.1,5.1,3.4,6.1,6.3l-2.6,1 c-1.6-4.2-6.1-6.3-10.3-4.8c-3.1,1.2-5.2,4.2-5.2,7.5c0,3.3,2,6.3,5.1,7.4L154.9,49.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "glass04"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 90.4,
    className: "st0",
    width: 20.4,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.6,74.1c-5.7,0-20.6-3.3-20.6-18.5c0.1-9,1.6-17.9,4.8-26.3c0.2-0.5,0.7-0.8,1.3-0.8h29.1 c0.5,0,1.1,0.3,1.3,0.8c3.1,8.4,4.7,17.3,4.8,26.3C148.1,70.8,133.2,74.1,127.6,74.1z M113.9,31.2c-2.7,7.8-4.2,16.1-4.2,24.4 c0,15.6,17.6,15.8,17.9,15.8s17.8-0.2,17.8-15.8c-0.1-8.3-1.5-16.6-4.2-24.4H113.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.2,
    y: 72.8,
    className: "st0",
    width: 2.7,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.1,
    y: 44.2,
    className: "st0",
    width: 36.9,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.4,61.7c-0.2,0-0.3-0.1-0.5-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.3c-0.1-0.2-0.1-0.3,0-0.5c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.3 c0.1-0.1,0.1-0.1,0.1-0.2c0.5-0.5,1.4-0.5,1.9,0c0.3,0.3,0.4,0.6,0.4,1c0,0.1,0,0.2,0,0.3s-0.1,0.2-0.1,0.3c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.1,0.2C115.2,61.6,114.8,61.7,114.4,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134,67c-0.1,0-0.2,0-0.3,0l-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.1s-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.2,0.1-0.3,0.1-0.5c0.1-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.1-0.2c0.5-0.5,1.4-0.5,1.9,0c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.1,0,0.2,0,0.3s-0.1,0.2-0.1,0.3c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2C134.8,66.9,134.4,67.1,134,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.7,54.6c-0.3,0-0.7-0.1-1-0.4c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.3 c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.7,0.4-1c0.5-0.5,1.4-0.5,1.9,0c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1 C120.5,54.4,120.1,54.7,119.7,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.4,67.5c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.1-0.4-0.3c-0.3-0.3-0.4-0.6-0.4-1c0-0.2,0.1-0.3,0.1-0.5 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2c0.3-0.3,0.7-0.5,1.2-0.4c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.1c0.5,0.5,0.5,1.4,0,1.9l0,0C125.1,67.3,124.8,67.5,124.4,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.4,54.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.3-0.3-0.4-0.6-0.4-1c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.3-0.1c0.5-0.1,0.9,0.1,1.2,0.3c0.1,0.1,0.1,0.1,0.1,0.2 c0.1,0.1,0.1,0.1,0.1,0.2s0.1,0.1,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3s-0.1,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.1,0.2C136.1,54,135.7,54.1,135.4,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,35.9c-5.5-2.3-8.1-8.7-5.8-14.2c2.3-5.5,8.7-8.1,14.2-5.8c4,1.7,6.6,5.7,6.6,10h-2.7 c0-4.5-3.6-8.1-8.1-8.1s-8.1,3.6-8.1,8.1c0,3.3,2,6.2,4.9,7.4L106.5,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.4,60.6l-2.7-0.5l7-41.9c0.1-0.5,0.5-1,1-1.1l16.7-4l0.6,2.7l-15.8,3.7L129.4,60.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 90.4,
    className: "st0",
    width: 20.4,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.6,74.1c-5.7,0-20.6-3.3-20.6-18.5c0.1-9,1.6-17.9,4.8-26.3c0.2-0.5,0.7-0.8,1.3-0.8h29.1 c0.5,0,1.1,0.3,1.3,0.8c3.1,8.4,4.7,17.3,4.8,26.3C148.1,70.8,133.2,74.1,127.6,74.1z M113.9,31.2c-2.7,7.8-4.2,16.1-4.2,24.4 c0,15.6,17.6,15.8,17.9,15.8s17.8-0.2,17.8-15.8c-0.1-8.3-1.5-16.6-4.2-24.4H113.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.2,
    y: 72.8,
    className: "st0",
    width: 2.7,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.1,
    y: 44.2,
    className: "st0",
    width: 36.9,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.4,61.7c-0.2,0-0.3-0.1-0.5-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.3c-0.1-0.2-0.1-0.3,0-0.5c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.3 c0.1-0.1,0.1-0.1,0.1-0.2c0.5-0.5,1.4-0.5,1.9,0c0.3,0.3,0.4,0.6,0.4,1c0,0.1,0,0.2,0,0.3s-0.1,0.2-0.1,0.3c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.1,0.2C115.2,61.6,114.8,61.7,114.4,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134,67c-0.1,0-0.2,0-0.3,0l-0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.1s-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2 c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.2,0.1-0.3,0.1-0.5c0.1-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.1-0.2c0.5-0.5,1.4-0.5,1.9,0c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.1,0,0.2,0,0.3s-0.1,0.2-0.1,0.3c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2C134.8,66.9,134.4,67.1,134,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.7,54.6c-0.3,0-0.7-0.1-1-0.4c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.3 c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.7,0.4-1c0.5-0.5,1.4-0.5,1.9,0c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1 C120.5,54.4,120.1,54.7,119.7,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.4,67.5c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.1-0.4-0.3c-0.3-0.3-0.4-0.6-0.4-1c0-0.2,0.1-0.3,0.1-0.5 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2c0.3-0.3,0.7-0.5,1.2-0.4c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.1c0.5,0.5,0.5,1.4,0,1.9l0,0C125.1,67.3,124.8,67.5,124.4,67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.4,54.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.3-0.3-0.4-0.6-0.4-1c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.3-0.1c0.5-0.1,0.9,0.1,1.2,0.3c0.1,0.1,0.1,0.1,0.1,0.2 c0.1,0.1,0.1,0.1,0.1,0.2s0.1,0.1,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3s-0.1,0.1-0.1,0.2 c-0.1,0.1-0.1,0.1-0.1,0.2C136.1,54,135.7,54.1,135.4,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,35.9c-5.5-2.3-8.1-8.7-5.8-14.2c2.3-5.5,8.7-8.1,14.2-5.8c4,1.7,6.6,5.7,6.6,10h-2.7 c0-4.5-3.6-8.1-8.1-8.1s-8.1,3.6-8.1,8.1c0,3.3,2,6.2,4.9,7.4L106.5,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.4,60.6l-2.7-0.5l7-41.9c0.1-0.5,0.5-1,1-1.1l16.7-4l0.6,2.7l-15.8,3.7L129.4,60.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "glass05"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.8,77.6C66.3,61.3,66.4,45.7,66.4,45l1.1-24.6c0-0.7,0.6-1.3,1.4-1.3h11v2.7h-9.7l-1,23.2 c0,0.1-0.1,15.4,11.8,30.9L78.8,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.6,91.7V76.8c0-0.3,0.1-0.6,0.3-0.8c12-15.5,11.8-30.7,11.8-30.9l-1-23.2h-9.7v-2.7h11 c0.7,0,1.4,0.5,1.4,1.3L93.4,45c0,0.7,0.2,16.1-12.1,32.3v14.5L78.6,91.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.2,
    y: 34.6,
    className: "st0",
    width: 23.4,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,51.8l-2.7-0.7l9.7-39c0.3-1.3,1.2-2.5,2.3-3.1c1-0.5,2.2-0.7,3.3-0.3l10.8,3.5l-0.8,2.6l-10.8-3.5 c-0.4-0.1-0.8-0.1-1.2,0.1c-0.5,0.3-0.9,0.8-1,1.4L81.2,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.9,43.8c-0.1,0-0.2,0-0.3,0s-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.3,0.1-0.7,0.4-1c0.5-0.5,1.4-0.5,1.9,0 c0.3,0.3,0.4,0.6,0.4,1c0,0.2-0.1,0.3-0.1,0.5C75,43.1,75,43.2,75,43.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.1 c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.3,0.1C74.1,43.8,74,43.8,73.9,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.3,50c-0.7,0-1.4-0.6-1.4-1.4c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.1,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2 c0.1-0.1,0.1-0.1,0.1-0.2c0.5-0.5,1.4-0.5,1.9,0c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.1,0.3 c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.7-0.4,1C72,49.9,71.7,50,71.3,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,61.4c-0.7,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.4,1.4-1.4c0.1,0,0.2,0,0.3,0s0.2,0.1,0.3,0.1 c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.3,0.1,0.5 c0,0.3-0.1,0.7-0.4,1C78.4,61.3,78,61.4,77.6,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.7,57.7c-0.7,0-1.4-0.6-1.4-1.4c0-0.3,0.1-0.7,0.4-1c0.1-0.1,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.3-0.1 c0.1-0.1,0.1-0.1,0.3-0.1c0.2-0.1,0.3-0.1,0.5,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.1 c0.4,0.4,0.5,1,0.3,1.5c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.4,0.3C86,57.7,85.9,57.7,85.7,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86,46.3c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.3-0.1C85.1,46,85,45.9,85,45.9 c-0.3-0.3-0.4-0.6-0.4-1c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2 c0.3-0.3,0.7-0.5,1.2-0.3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2 c0.1,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.3,0.1,0.5c0,0.3-0.1,0.7-0.4,1c-0.1,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.1-0.2,0.1 c-0.1,0-0.1,0.1-0.3,0.1C86.2,46.2,86.1,46.3,86,46.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1,
    y: 90.4,
    className: "st0",
    width: 15.7,
    height: 2.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkIcon05);
export default __webpack_public_path__ + "static/media/drink-icon-05.35f546c9.svg";
export { ForwardRef as ReactComponent };